export const DEFAULT_VISIBLE_MODULES_DESKTOP = 4
export const DEFAULT_VISIBLE_MODULES_MOBILE = 3

export const MODULES_PAGINATION_INCREMENT = 1
